UAEditDefaultQuotasCtrl.$inject = ['userUuids', 'product', 'adminApi', 'domainInfo', '$uibModalInstance']

const quotaOptionsForProduct = {
  toolkit: [
    { label: 'Toolkit Copy Quota', key: 'monthly_copy_quota' },
    { label: 'Toolkit Print Quota', key: 'monthly_print_quota' },
    { label: 'Toolkit Download Quota', key: 'monthly_resource_download_quota' }
  ],
  pathways: [
    { label: 'Pathways Copy Quota', key: 'copy_quota' },
    { label: 'Pathways Print Quota', key: 'print_quota' },
    { label: 'Pathways Download Quota', key: 'resource_download_limit' }
  ]
}

export default function UAEditDefaultQuotasCtrl(userUuids, product, adminApi, domainInfo, $modalInstance) {
  this.showError = false
  this.errorMessage = ''
  this.successMessage = ''
  this.saving = false
  this.product = product
  this.domainDefaults = null

  this.$onInit = () => {
    this.quotas = {}
    this.quotaOptions = quotaOptionsForProduct[product]

    this.quotaOptions.forEach(({ key }) => {
      this.quotas[key] = ''
    })

    if (product === 'toolkit' && domainInfo?.toolkit_default_quotas) {
      this.domainDefaults = domainInfo.toolkit_default_quotas
    }
  }

  this.hasDomainDefaults = () => {
    return this.domainDefaults && (
      this.domainDefaults.monthly_copy_quota > 0 ||
      this.domainDefaults.monthly_resource_download_quota > 0 ||
      this.domainDefaults.monthly_print_quota > 0
    )
  }

  this.getDomainDefaultForQuota = (quotaKey) => {
    if (!this.domainDefaults) return null    
    return this.domainDefaults[quotaKey] ?? null
  }

  this.updateQuotas = function() {
    this.saving = true
    this.showError = false
    this.successMessage = ''

    adminApi.batchUpdateProductAccounts(product, userUuids, this.quotas).then(
      numUpdated => {
        this.saving = false
        this.successMessage = `${numUpdated} accounts updated`
      },
      reason => {
        this.showError = true
        this.errorMessage = reason
        this.saving = false
      }
    )
  }
}
